<template>
    <div>
        <div class="block w-full rounded-lg bg-white p-3 border" :class="{ 'max-w-4xl': !fullWidth }">
            <label class="block text-gray-700 mb-2">{{ label }}</label>
            <btn
                :disabled="disabled"
                type="button"
                :content="selectItemText"
                @click="isOpen = !isOpen"
            />
            <p class="text-gray-700 my-3" v-if="selectedFiles.length">
                Linked:
                <span v-if="debugStore.debugMode" class="font-mono">
                    [ID<span v-if="selectedFiles.length > 1">s</span>:
                    {{ selectedFiles.map(e => e.id).join(', ') }}]
                </span>
            </p>
            <media-library
                :single-item="!multiple"
                :draggable="draggable"
                :deletable="deletable"
                :feeds-into-gallery="feedsIntoGallery"
                :gallery="gallery"
                :interactive="false"
                @add-to-gallery="(file) => $emit('add-to-gallery', file)"
                @remove-from-gallery="(file) => $emit('remove-from-gallery', file)"
                @input="setValue"
                :media-data="selectedFiles"
            ></media-library>
        </div>
        <media-reference-modal
            :media-types="mediaTypes"
            :language="language"
            :multiple="multiple"
            :active="isOpen"
            :upload="upload"
            v-model="selectedFiles"
            @closed="isOpen = false"
        />
        <input
            type="hidden"
            v-for="(file, index) in selectedFiles"
            :key="`file${index}`"
            :name="selectedFiles.length === 1 ? name : `${name}[]`"
            :value="file ? file.id : null"
        />
        <error :error="error" />
    </div>
</template>

<script>
import MediaReferenceModal from "./MediaReferenceModal";
import MediaLibrary from "./MediaLibrary";
import siteLanguage from '../../config/siteLanguage'
import {useDebugStore} from "../../stores/debug";

export default {
    name: "MediaReference",
    components: { MediaLibrary, MediaReferenceModal },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        deletable: {
            type: Boolean,
            default: false,
            required: false
        },
        value: [Object, Array],
        label: String,
        feedsIntoGallery: Boolean,
        name: String,
        upload: {
            type: Boolean,
            default: true,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
        multiple: Boolean,
        gallery: Array,
        mediaTypes: {
            type: Array,
            required: false,
            default: () => {
                return ["Media"] ;
            },
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
        error: {
            type: String,
            required: false,
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
            selectedFiles: [],
            debugStore: useDebugStore(),
        };
    },
    created() {
        this.setValue(this.value);
    },
    updated() {
        this.$emit(
            "input",
            this.multiple ? this.selectedFiles : this.selectedFiles[0]
        );
    },
    methods: {
        setValue: function(value) {
            if (value) {
                this.selectedFiles = Array.isArray(value) ? value : [value];
            } else {
                this.selectedFiles = [];
            }
        },
    },
    computed: {
        selectItemText: function () {
            let buttonText = "Select";
            let mediaTypesLength = this.mediaTypes.length;

            for (let mediaType = 0; mediaType < mediaTypesLength; mediaType++) {
                buttonText += " " + this.mediaTypes[mediaType].split(/(?=[A-Z])/).join(" ");
                if (mediaType < mediaTypesLength-1) {
                    buttonText += ",";
                }
            }
            return buttonText;
        },
    },
    watch: {
        value: function (newValue) {
            this.setValue(newValue);
        }
    }
};
</script>
